import React, { Component } from "react";

const AdmissionContext = React.createContext();
export const AdmissionConsumer = AdmissionContext.Consumer;

export class AdmissionProvider extends Component {
  state = {
    loading: false,
    agree: false,
    admission: false,
    activeStep: 0,
    newEnrolle: true,
    //start from api
    semester: 1,
    year: "",
    ano: "",
    undergraduate: [],
    graduate: [],
    preferred: [],
    secondChoice: [],
    track: [],
    region: [],
    province: [],
    city: [],
    barangay: [],
    //end from api
    studentType: {
      studentType: null,
      academic: null,
      major: null,
      preferred: null,
      secondChoice: null,
      required: false,
    },
    personalInformation: {
      lastName: "",
      firstName: "",
      middleName: "",
      maidenName: "",
      dateofBirth: null,
      placeOfBirth: "",
      gender: null,
      civilStatus: null,
      religion: "",
      citizenship: "",
      required: false,
    },
    address: {
      houseNo: "",
      street: "",
      barangay: "",
      city: "",
      province: "",
      region: "",
      zipCode: "",
      required: false,
    },
    contact: {
      email: "",
      mobileno: "",
      fathersName: "",
      fathersOccupation: "",
      fathersAddress: "",
      fathersContactNo: "",
      mothersName: "",
      mothersOccupation: "",
      mothersAddress: "",
      mothersContactNo: "",
      guardianName: "",
      guardianRelationship: "",
      guardianAddress: "",
      guardianOccupation: "",
      guardianContactNo: "",
      averageFamilyIncome: null,
      required: false,
    },
    school: {
      shsName: "",
      shsAddress: "",
      lrn: "",
      shsTrack: null,
      shsStrand: null,
      shsInclusiveDate: null,
      collegeCourse: "",
      collegeName: "",
      collegeAddress: "",
      collegeInclusiveDate: null,
      gradIntermediate : "",
      gradIntermediateYear : null,
      gradShs : "",
      gradShsYear : "",
      gradCollege : "",
      gradCollegeYear : "",
      gradHighestYearCompleted : "",
      gradLastSchoolAttended : "",
    },
    attachment: {
      imgGoodMoral: [],
      imgBirthCertificate: [],
      imgReportCard: [],
      imgPicture: [],
      imgCopyofTOR: [],
      imgClearance: [],
      imgEvaluation: [],
      files: [],
    },
    others: {
      fa: false,
      faSpecify: "",
      ig: false,
      igSpecify: "",
      sp: false,
      pwd: false,
      required: false,
    },
    database: {
      url: "",
      username: "",
      password: "",
    },
    mail: {
      domain: "",
      apiKey: "",
      from: "",
      to: "",
      subject: "",
      template: "",
    },
  };

  initState = () => {
    this.setState({
      loading: false,
      agree: false,
      admission: false,
      activeStep: 0,
      newEnrolle: true,
      ano: "",
      //start from api
      // semester: 1,
      // year: "",
      // course: [],
      // track: [],
      //end from api
      studentType: {
        studentType: null,
        academic: null,
        preferred: null,
        secondChoice: null,
      },
      personalInformation: {
        lastName: "",
        firstName: "",
        middleName: "",
        maidenName: "",
        dateofBirth: null,
        placeOfBirth: "",
        gender: null,
        civilStatus: null,
        religion: "",
        citizenship: "",
        required: false,
      },
      address: {
        houseNo: "",
        street: "",
        barangay: "",
        city: "",
        province: "",
        region: "",
        zipCode: "",
        required: false,
      },
      contact: {
        email: "",
        mobileno: "",
        fathersName: "",
        fathersOccupation: "",
        fathersAddress: "",
        fathersContactNo: "",
        mothersName: "",
        mothersOccupation: "",
        mothersAddress: "",
        mothersContactNo: "",
        guardianName: "",
        guardianRelationship: "",
        guardianAddress: "",
        guardianOccupation: "",
        guardianContactNo: "",
        averageFamilyIncome: null,
        required: false,
      },
      school: {
        shsName: "",
        shsAddress: "",
        lrn: "",
        shsTrack: null,
        shsStrand: null,
        shsInclusiveDate: null,
        collegeCourse: "",
        collegeName: "",
        collegeAddress: "",
        collegeInclusiveDate: null,
        gradIntermediate : "",
        gradIntermediateYear : null,
        gradShs : "",
        gradShsYear : "",
        gradCollege : "",
        gradCollegeYear : "",
        gradHighestYearCompleted : "",
        gradLastSchoolAttended : "",
        required: false,
      },
      attachment: {
        imgGoodMoral: [],
        imgBirthCertificate: [],
        imgReportCard: [],
        imgPicture: [],
        imgCopyofTOR: [],
        imgClearance: [],
        imgEvaluation: [],
        files: [],
        required: false,
      },
      others: {
        fa: false,
        faSpecify: "",
        ig: false,
        igSpecify: "",
        sp: false,
        pwd: false,
        required: false,
      },
    });
  };

  SetDatabase = (value) => {
    this.setState({
      database: value,
    });
  };

  SetMail = (value) => {
    this.setState({
      mail: value,
    });
  };

  SetAcademicYear = (semester, year) => {
    this.setState({
      semester: semester,
      year: year,
    });
  };

  SetUndergraduateCourse = (value) => {
    this.setState({
      undergraduate: value,
    });
  };

  SetGraduateCourse = (value) => {
    this.setState({
      graduate: value,
    });
  };

  SetPreferredCourse = (value) => {
    this.setState({
      preferred: value,
    });
  };

  SetSecondChoiceCourse = (value) => {
    this.setState({
      secondChoice: value,
    });
  };

  SetTrack = (value) => {
    this.setState({
      track: value,
    });
  };

  SetRegion = (value) => {
    this.setState({
      region: value,
    });
  };

  SetProvince = (value) => {
    this.setState({
      province: value,
    });
  };

  SetCity = (value) => {
    this.setState({
      city: value,
    });
  };

  SetBarangay = (value) => {
    this.setState({
      barangay: value,
    });
  };

  SetStudentType = (value) => {
    this.setState({
      studentType: value,
    });
  };

  SetPersonalInformation = (value) => {
    this.setState({
      personalInformation: value,
    });
  };

  SetAddress = (value) => {
    this.setState({
      address: value,
    });
  };

  SetContact = (value) => {
    this.setState({
      contact: value,
    });
  };

  SetSchool = (value) => {
    this.setState({
      school: value,
    });
  };

  SetAttachment = (value) => {
    this.setState({
      attachment: value,
    });
  };

  SetOthers = (value) => {
    this.setState({
      others: value,
    });
  };

  SetAno = (value) => {
    this.setState({
      ano: value,
      activeStep: 7,
    });
  };

  chkAgreeValueChange = (value) => {
    this.setState({
      agree: value,
    });
  };

  btnContinueClicked = () => {
    if (this.state.agree) {
      this.setState({
        activeStep: 0,
        admission: true,
      });
    }
  };

  btnNextClicked = () => {
    const { activeStep } = this.state;
    if (activeStep < 6) {
      this.setState({
        activeStep: activeStep + 1,
      });
    }
  };

  btnBackClicked = () => {
    const { activeStep } = this.state;
    if (activeStep > 0) {
      this.setState({
        activeStep: activeStep - 1,
      });
    }
  };

  loadingValueChange = (value) => {
    this.setState({
      loading: value,
    });
  };

  render() {
    const {
      database,
      mail,
      loading,
      agree,
      admission,
      activeStep,
      newEnrolle,
      semester,
      year,
      undergraduate,
      graduate,
      preferred,
      secondChoice,
      track,
      region,
      province,
      city,
      barangay,
      studentType,
      personalInformation,
      address,
      contact,
      school,
      attachment,
      others,
      ano,
    } = this.state;
    const {
      SetDatabase,
      SetMail,
      chkAgreeValueChange,
      loadingValueChange,
      btnContinueClicked,
      btnNextClicked,
      btnBackClicked,
      initState,
      SetAcademicYear,
      SetUndergraduateCourse,
      SetGraduateCourse,
      SetPreferredCourse,
      SetSecondChoiceCourse,
      SetTrack,
      SetRegion,
      SetProvince,
      SetCity,
      SetBarangay,
      SetStudentType,
      SetPersonalInformation,
      SetAddress,
      SetContact,
      SetSchool,
      SetAttachment,
      SetOthers,
      SetAno,
    } = this;

    return (
      <AdmissionContext.Provider
        value={{
          database,
          mail,
          agree,
          loading,
          admission,
          activeStep,
          newEnrolle,
          semester,
          year,
          undergraduate,
          graduate,
          preferred,
          secondChoice,
          track,
          region,
          province,
          city,
          barangay,
          studentType,
          personalInformation,
          address,
          contact,
          school,
          attachment,
          others,
          ano,
          SetDatabase,
          SetMail,
          chkAgreeValueChange,
          loadingValueChange,
          btnContinueClicked,
          btnNextClicked,
          btnBackClicked,
          initState,
          SetAcademicYear,
          SetUndergraduateCourse,
          SetGraduateCourse,
          SetPreferredCourse,
          SetSecondChoiceCourse,
          SetTrack,
          SetRegion,
          SetProvince,
          SetCity,
          SetBarangay,
          SetStudentType,
          SetPersonalInformation,
          SetAddress,
          SetContact,
          SetSchool,
          SetAttachment,
          SetOthers,
          SetAno,
        }}
      >
        {this.props.children}
      </AdmissionContext.Provider>
    );
  }
}

export default AdmissionContext;
